import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row} from 'react-bootstrap';
import './Weeksmenu.css';


const Weeksmenu = observer(
  class Weeksmenu extends Component {
	
		state = {baba:'dudu'};
		
		
		
		toggleWeek(w) {
			w  = new Date().getFullYear() + '-S' + w;
			let ch = this.props.skweeks;
			if(ch.indexOf(w) > -1)  
				ch.splice(ch.indexOf(w),1)
			else
				ch.push(w);
			this.props.setcritcb({weeks:ch});
		}
		
		mkClass(w) {
			w  = new Date().getFullYear() + '-S' + w;
			if(this.props.skweeks.indexOf(w) > -1)  
				return 'weeklnk selected';
			return 'weeklnk';
		}
		
		
		
		// Returns the ISO week of the date.
		getWeek = function(plusdays = 0) {
			var today = new Date();
			var date = new Date(today.getTime() + plusdays * 24 * 60 * 60 * 1000);
			 date.setHours(0, 0, 0, 0);
			date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
			var week1 = new Date(date.getFullYear(), 0, 4);
			let w = 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
			return w;
		}
			
		getWeeks	= function() {
				return [this.getWeek(),this.getWeek(7),this.getWeek(14),this.getWeek(21)];
		}

			
    render() {
			// let d = new Date();
			let ws = this.getWeeks();
			return  (
					<>
					<div className="genresbigheader">Semaine</div>
						<div className="weekscont">
						{ws.map(w => {
							return (<div key={w} onClick={()=>{ this.toggleWeek(w) }} className={this.mkClass(w)}>{w}</div>)
						})}
						</div>
					</>
			)
    }
		
		
		
  }
)


export default Flow.injectFlow(Weeksmenu);